import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const FinanceStatus = ({ stats }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'KES'
        }).format(amount || 0);
    };

    return (

        <Row>
            <Col lg={4} md={4} className="mb-4">
                <Card className="stats-card text-white" style={{ background: 'linear-gradient(135deg, var(--brand-charcoal), var(--brand-burgundy))' }}>
                    <Card.Body className="text-center">
                        <div className="display-4 fw-bold">{stats.total_unpaid_invoices || '-'}</div>
                        <div className="fs-6">Pending Invoices</div>
                    </Card.Body>
                </Card>
            </Col>
            <Col lg={4} md={4} className="mb-4">
                <Card className="stats-card text-white" style={{ background: 'linear-gradient(135deg, var(--brand-burgundy), var(--brand-charcoal))' }}>
                    <Card.Body className="text-center">
                        <div className="display-4 fw-bold">{formatCurrency(stats.unlinked_payments_value)}</div>
                        <div className="fs-6">Unreconcilled Revenue</div>
                    </Card.Body>
                </Card>
            </Col>
            <Col lg={4} md={4} className="mb-4">
                <Card className="stats-card text-white" style={{ background: 'linear-gradient(135deg, var(--brand-charcoal), var(--brand-burgundy))' }}>
                    <Card.Body className="text-center">
                        <div className="display-4 fw-bold">{stats.non_current_subscriptions || '-'}</div>
                        <div className="fs-6">Non Current Subscriptions</div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default FinanceStatus;
